/**
 * 乘客端 DidiJSBridge 封装
 * @author huangyiustb
 * @modify xuxiaoyan
 */

import { isAndroid, isIOS, logger, invokeInTurn } from '../util'
import { callIOS } from './ios'
import { callAndroid } from './android'
import { compareAppVersion } from '../ddbridge/app'
import { bridgeReady } from '../core/bridge'
import { passengerConfig } from '../config'

let DDBridgePassenger = {}

const defaultFn = function () {}

//通过初始化注册客户端事件回调Handler
//http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588

// function init() {
// 	let triggerName = '__bridgeTrigger__'
//
// 	window[triggerName] = function (retData) {
// 		if (typeof retData === 'string') {
// 			try {
// 				retData = JSON.parse(retData)
// 			} catch (e) {
// 				retData = {}
// 			}
// 		}
// 		let eventName = retData.eventname
// 		let errno = retData.errno
// 		let err = null
//
// 		if (errno !== ERR_OK) {
// 			let msg = retData.errmsg
// 			err = new Error(msg)
// 		}
//
// 		events.emit(eventName, err, retData.result)
// 	}
//
// 	call('initConfig', {
// 		handler: triggerName
// 	}, '')
// }
//
// init()

function _call(method, param, callback) {
  if (isAndroid) {
    callAndroid(method, param, callback)
  } else {
    callIOS(method, param, callback)
  }
}

function call(method, param, callback) {
  invokeInTurn(_call, arguments)
}


/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function passengerBridgeFn(name, conf, isOldVersion) {
  return function (param = {}, callback = defaultFn) {

    if (arguments.length === 1 && typeof param === 'function') {
      callback = param
      param = {}
    }

    // 根据版本号区分ddbridge和echo
    // http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
    let method = name,
        isAndlite = isAndroid && compareAppVersion('>=', '5.0.0'),
        isIoslite = isIOS && compareAppVersion('>=', '5.0.0')

    if (!isOldVersion && (isIoslite || isAndlite)) {
      logger({
        pos: 'CALL_BRIDGE',
        version: '5.x',
        method
      })
      call(method, param, callback)
    } else {

      if (conf && conf.fn) {
        method = conf.fn
      }
      setTimeout(() => { // hack
        bridgeReady((bridge) => {
          bridge.callHandler(method, param, data => {

            if (typeof data == 'string') {
              data = JSON.parse(data)
            }

            callback(null, data)
          })
        })
      }, 0)

      logger({
        pos: 'callBridge',
        version: '4.x',
        method
      })
    }

  }
}

/**
 * 乘客端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initPassengerBaseCall(DDBridge) {
  // isOldVersion 强制使用老版本ddbridge
  DDBridge.call = function (method, param, callback, isOldVersion) {
    let conf = passengerConfig[method],
        bridgeFn = passengerBridgeFn(method, conf, isOldVersion)

    if (!callback && typeof param === 'function') {
      callback = param
      param = {}
    }

    return bridgeFn(param, callback)
  }
  return DDBridge
}

initPassengerBaseCall(DDBridgePassenger)

export { DDBridgePassenger }



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgepassenger/index.js